const PENDING_KEY = 'oidc_step_up_pending'
const RESULT_KEY = 'oidc_step_up_result'

const PENDING_TTL = 10 * 60 * 1000 // time at the IdP
const RESULT_TTL = 2 * 60 * 1000 // time to resume

const read = (key) => {
    try {
        return JSON.parse(sessionStorage.getItem(key) || 'null')
    } catch (e) {
        return null
    }
}

const isFresh = (marker, ttl) => Boolean(marker) && Date.now() - marker.at < ttl

export const setOidcStepUpPending = (action_key) => {
    sessionStorage.setItem(PENDING_KEY, JSON.stringify({ action_key, at: Date.now() }))
}

export const clearOidcStepUpPending = () => sessionStorage.removeItem(PENDING_KEY)

// Stale markers are dropped.
export const getOidcStepUpPending = () => {
    const pending = read(PENDING_KEY)

    if (isFresh(pending, PENDING_TTL)) return pending
    clearOidcStepUpPending()
    return null
}

// Turns the pending marker into a result.
export const finishOidcStepUp = (is_verified) => {
    const pending = getOidcStepUpPending()

    clearOidcStepUpPending()
    if (!pending) return
    sessionStorage.setItem(RESULT_KEY, JSON.stringify({ action_key: pending.action_key, is_verified, at: Date.now() }))
}

export const hasOidcStepUpResult = (action_key) => {
    const result = read(RESULT_KEY)

    return isFresh(result, RESULT_TTL) && result.action_key === action_key
}

// 'verified' | 'failed' | ''. Other actions' results are left alone.
export const consumeOidcStepUp = (action_key) => {
    const result = read(RESULT_KEY)

    if (!result) return ''
    const is_fresh = isFresh(result, RESULT_TTL)
    if (is_fresh && result.action_key !== action_key) return ''
    sessionStorage.removeItem(RESULT_KEY)
    if (!is_fresh) return ''
    return result.is_verified ? 'verified' : 'failed'
}

export const clearOidcStepUp = () => {
    clearOidcStepUpPending()
    sessionStorage.removeItem(RESULT_KEY)
}

// Reads the uid from a Firebase custom token.
export const readCustomTokenUid = (token) => {
    try {
        const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')

        return JSON.parse(atob(payload)).uid || ''
    } catch (e) {
        return ''
    }
}
